module.exports = __webpack_public_path__ + "img/logo.88ec5cdb.svg";